{
  "id": "icons-menu",
  "class": "icon",
  "size": {
    "w": 16,
    "h": 16
  },
  "anchor": {
    "x": 8,
    "y": 8
  },
  "palette": {
    "k": "#23140b",
    "u": "#7d471e",
    "U": "#9b5d27",
    "d": "#472713",
    "c": "#dcc096",
    "C": "#efe0c2",
    "s": "#b89062",
    "y": "#e6b832",
    "Y": "#f7d969",
    "g": "#be7934",
    "r": "#a82c2c",
    "R": "#cf4a4a",
    "D": "#731c1c",
    "n": "#d6d0c6",
    "N": "#aaa399",
    "e": "#7a736b"
  },
  "frames": {
    "book": [
      "................",
      "................",
      "................",
      "..kkkkk..kkkkk..",
      ".kCCCCCkkCCCCCk.",
      ".kCkkkCkkCkkkCk.",
      ".kCCCCCkkCCCCCk.",
      ".kCkkkCkkCkkkCk.",
      ".kCCCCCkkCCCCCk.",
      ".kCkkCCkkCkkCCk.",
      ".kCcccckkccccCk.",
      ".kRRrrrkkrrrDDk.",
      "..kkkkkkkkkkkk..",
      "................",
      "................",
      "................"
    ],
    "badges": [
      "................",
      "......kkkk......",
      "....kkYYYYkk....",
      "...kYYkkYYggk...",
      "..kYYkkkkkkggk..",
      "..kYYykkkkyggk..",
      "..kYYkkyykkygk..",
      "...kYYggggggk...",
      "....kkkkkkkk....",
      "....kRRkkRRk....",
      "...kRRrkkrrRk...",
      "...kRrrkkrrDk...",
      "...krDk..kDrk...",
      "....kk....kk....",
      "................",
      "................"
    ],
    "trophies": [
      "................",
      "................",
      "..kkkkkkkkkkkk..",
      ".kYYyyyyyyyyggk.",
      "kYYkkYYYYyykkggk",
      "kYYk.kYYYYk.kggk",
      "kYk..kYyyk...kgk",
      ".kk..kYyyk...kk.",
      ".....kYyyk......",
      "......kygk......",
      ".....kkyykk.....",
      "....kyyyyyykk...",
      "...kgyyyyyyggk..",
      "...kkkkkkkkkkk..",
      "................",
      "................"
    ],
    "items": [
      "................",
      ".....kk..kk.....",
      "....kYYkkYYk....",
      "...kYYYkkkYYk...",
      "....kkk..kkk....",
      "..kkkkkkkkkkkk..",
      "..kRRRkyykkRRk..",
      "..kRRRkyykrrDk..",
      "..kkkkkkkkkkkk..",
      "..krrrkyykrDDk..",
      "..krrrkyykrDDk..",
      "..krrrkyykrDDk..",
      "..kkkkkkkkkkkk..",
      "................",
      "................",
      "................"
    ],
    "more": [
      "................",
      "................",
      "................",
      "................",
      "................",
      "...kk...kk...kk.",
      "..knnkkknnkkknnk",
      "..kNNkkkNNkkkNNk",
      "...kk...kk...kk.",
      "................",
      "................",
      "................",
      "................",
      "................",
      "................",
      "................"
    ]
  }
}
